import {
  ChatBubbleIcon,
  FaceIcon,
  Cross1Icon,
  RulerSquareIcon,
  StarIcon,
  PersonIcon,
} from "@radix-ui/react-icons";

export function getIcon(iconName, ...props) {
  switch (iconName) {
    case "Face":
      return <FaceIcon {...props} />;
    case "Star":
      return <StarIcon {...props} />;
    case "Person":
      return <PersonIcon {...props} />;
    case "Cross1":
      return <Cross1Icon {...props} />;
    case "RulerSquare":
      return <RulerSquareIcon {...props} />;
    default:
      return <ChatBubbleIcon {...props} />;
  }
}
